import { createFileRoute, redirect, useParams } from '@tanstack/react-router';

import { PackagePatternConfigDetail } from '@/features/operation-package-config-new/PackagePatternDetail';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { isSelfReportPatternId } from '@/routes/_staff/it-operation-core/_root/in-house-packages/-query/api';

import { useItOperationCoreEligibleTargetSlot } from './-hooks/useItOperationCoreEligibleTargetSlot';

export const Route = createFileRoute(
  '/_staff/it-operation-core/config/$patternId/',
)({
  beforeLoad: ({ params }) => {
    // セルフレポートのパターンは専用の設問エディタへ委譲する（モック）
    if (isSelfReportPatternId(params.patternId)) {
      throw redirect({
        to: '/it-operation-core/self-report-patterns/$patternId',
        params: { patternId: params.patternId },
      });
    }
  },
  component: PatternConfigPage,
});

function PatternConfigPage() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'pages.itOperationCore',
  });
  const { patternId } = useParams({
    from: '/_staff/it-operation-core/config/$patternId/',
  });

  // IT Operation Core固有の対象者設定UIを取得
  const eligibleTargetSlot = useItOperationCoreEligibleTargetSlot(patternId);

  return (
    <PackagePatternConfigDetail
      ownerProduct="IT_OPERATION_CORE"
      patternId={patternId}
      breadcrumbs={[
        {
          linkTo: '/it-operation-core/config',
          label: t('title'),
        },
      ]}
      eligibleTargetSlot={eligibleTargetSlot}
    />
  );
}
